import React, {useState, useRef} from 'react'
import { compose } from 'recompose';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import StyledIcon from '../../../../../../../styledComponents/styles/Icon.styled';
import style from "../modals/ImageUploadModal/style.scss";
import Dropzone from 'react-dropzone';
import FileUploadIcon from '../../../../../../travelerProfile/components/icons/FileUpoadIcon';
import FileIcon from '../../../../../../../components/pages/TravelerProfile/Messages/MessageComponent/CreateMessage/img/fileIcon';

export const enhance = compose(withStyles(style));

const UploadImageForm = ({setUploadedFile, uploadedFile, setIsError, isError}) => {
  const dropZoneRef = useRef('dropzone');
  const [errorMessage, setErrorMsg] = useState("");

  const onDrop = files => {
    let file = files[0];
    let extension = file.name
      .split('.')
      .pop()
      .toLowerCase();
    setIsError(false);
    const allowedExtensions = ['png', 'jpeg', 'jpg'];
    if (!allowedExtensions.includes(extension)) {
      setErrorMsg("Unsupported file format. Please upload a JPEG, PNG or JPG");
      setIsError(true);
      // toast('Unsupported file type, allowed types are png, jpeg, jpg', {
      //   type: 'error',
      //   className: toastMessageStyles['failureContainer'],
      //   toastClassName: toastMessageStyles['wrapper'],
      //   bodyClassName: toastMessageStyles['failureBody'],
      //   progressClassName: toastMessageStyles['progress-bar'],
      // });
      // return; // Exit the function if the file type is not allowed
    }
    if (file) {
      const sizeInMB = file.size / (1024 * 1024);
      if (sizeInMB.toFixed(2) > 10) {
        setErrorMsg("The selected image exceeds the 10 MB file size limit.");
        setIsError(true);
        // toast('File is too large, max is 10MB', {
        //   type: 'error',
        //   className: toastMessageStyles['failureContainer'],
        //   toastClassName: toastMessageStyles['wrapper'],
        //   bodyClassName: toastMessageStyles['failureBody'],
        //   progressClassName: toastMessageStyles['progress-bar'],
        // });
        //return;
      }
    }
    setUploadedFile(file);
  };

  const deletedSelectedImage = () => {
    setErrorMsg("");
    setIsError(false);
    setUploadedFile(null);
  }

  return (
    <div className={style.contentWrapper}>
      <div className={style.modalTitle}>Upload Carousel Images</div>
      <div className={style.modalSubTitle}>Upload an image for this program brochure. Recommended Width: 850 px. Height: 580 px </div>

      <div className={style.dropzoneWrapper}>
          <Dropzone
            ref={dropZoneRef}
            className={style.dropzone}
            onDrop={onDrop}
            activeStyle={{ backgroundColor: 'rgba(255, 255, 255, 0.4)' }}
            tabIndex={0}
            maxFiles={1}
            multiple={false}
            onKeyDown={e => {
              if (e.keyCode === 32 || e.keyCode === 13) {
                e => {
                  e.preventDefault();
                  dropZoneRef.open();
                };
              }
            }}
          >
            <div className={style.dropzoneLayout}>
              <div className={style.dropzoneText}>
                <div><FileUploadIcon /></div>
                <div className={style.dropzoneTextTitle}>Click or drag image file to this area to upload</div>
                <div className={style.dropzoneTextDesc}>Accepted File Types: .png, .jpeg, .jpg</div>
                <div className={style.dropzoneTextDesc}>Maximum file size 10MB</div>
              </div>
            </div>
          </Dropzone>
          {uploadedFile?.name &&
            <div className={`${style.imageNameWrapper}  `}>
              <div className={isError ? style.uploadedImageNameError : style.uploadedImageName}>
                <FileIcon width={"15px"} height={"15px"} color={isError ? "#A82425" : "#255A94"} />
                <div>{uploadedFile?.name}</div>
              </div>
              <button type="button" onClick={deletedSelectedImage} className={`${style.noBorderButton}  ${isError ? style.errorName : ""}`}> 
                <StyledIcon type={'Trash'} size={'13.777px'} /> 
              </button>
            </div>
          }
      </div>
      {isError &&
        <div className={style.warningBannerWrapper}>
          <div className={style.warningBanner}>
            <span>{errorMessage}</span>
          </div>
        </div>
      }
    </div>
  )
}

export default enhance(UploadImageForm)
